export default {
    byPublisher(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('publisherId', id).get()
            )
        )
    }
}
